import {
  PageBlockColorV2,
  PageBlockDefinition,
  PageBlockDefinitionBehavior,
  PageBlockDefinitionItem,
  PageBlockDefinitionLayout,
  PageBlockDefinitionProperty,
  PageBlockDefinitionVariant,
} from "@supernova-studio/model";
import { z } from "zod";

export const DTOPageBlockDefinitionBehavior = PageBlockDefinitionBehavior;
export const DTOPageBlockDefinitionItem = PageBlockDefinitionItem;
export const DTOPageBlockDefinitionLayout = PageBlockDefinitionLayout;
export const DTOPageBlockDefinitionVariant = PageBlockDefinitionVariant;
export const DTOPageBlockDefinitionProperty = PageBlockDefinitionProperty;
export const DTOPageBlockColorV2 = PageBlockColorV2;

export const DTOPageBlockDefinition = PageBlockDefinition;

export type DTOPageBlockDefinitionBehavior = z.infer<typeof DTOPageBlockDefinitionBehavior>;
export type DTOPageBlockDefinitionItem = z.infer<typeof DTOPageBlockDefinitionItem>;
export type DTOPageBlockDefinitionLayout = z.infer<typeof DTOPageBlockDefinitionLayout>;
export type DTOPageBlockDefinitionVariant = z.infer<typeof DTOPageBlockDefinitionVariant>;
export type DTOPageBlockDefinitionProperty = z.infer<typeof DTOPageBlockDefinitionProperty>;
export type DTOPageBlockColorV2 = z.infer<typeof DTOPageBlockColorV2>;

export type DTOPageBlockDefinition = z.infer<typeof DTOPageBlockDefinition>;
